import React, { createContext, useState } from "react";

export const CustomerContext = createContext();

export const CustomerProvider = ({ children }) => {
  const [customers, setCustomers] = useState([
  
    {
      id: 1,
      fullName: "Ahmet Yılmaz",
      email: "ahmet@example.com",
      phone1: "0555 111 22 33",
      phone2: "",
      customerType: "Bireysel",
      tcNo: "12345678901",
      vergiNo: "",
      vergiDairesi: "",
      city: "İstanbul",
      district: "Kadıköy",
      address: "Örnek Mah. No:5",
    },
    {
      id: 2,
      fullName: "Mehmet Kaya",
      email: "mehmet@example.com",
      phone1: "0555 222 33 44",
      phone2: "",
      customerType: "Kurumsal",
      tcNo: "",
      vergiNo: "9876543210",
      vergiDairesi: "Kadıköy Vergi Dairesi",
      city: "İstanbul",
      district: "Ataşehir",
      address: "Örnek Sok. No:7",
    },
    {
      id: 3,
      fullName: "Ayşe Demir",
      email: "ayse@example.com",
      phone1: "0555 333 44 55",
      phone2: "",
      customerType: "Bireysel",
      tcNo: "23456789012",
      vergiNo: "",
      vergiDairesi: "",
      city: "Ankara",
      district: "Çankaya",
      address: "Atatürk Bulvarı No:10",
    },
    {
      id: 4,
      fullName: "Ali Vural",
      email: "ali@example.com",
      phone1: "0555 444 55 66",
      phone2: "",
      customerType: "Kurumsal",
      tcNo: "",
      vergiNo: "4561237890",
      vergiDairesi: "Çankaya Vergi Dairesi",
      city: "Ankara",
      district: "Yenimahalle",
      address: "Cumhuriyet Cd. No:25",
    },
    {
      id: 5,
      fullName: "Zeynep Koç",
      email: "zeynep@example.com",
      phone1: "0555 555 66 77",
      phone2: "",
      customerType: "Bireysel",
      tcNo: "34567890123",
      vergiNo: "",
      vergiDairesi: "",
      city: "İzmir",
      district: "Konak",
      address: "Kordonboyu No:12",
    },
    {
      id: 6,
      fullName: "Canan Arslan",
      email: "canan@example.com",
      phone1: "0555 666 77 88",
      phone2: "",
      customerType: "Kurumsal",
      tcNo: "",
      vergiNo: "8529637410",
      vergiDairesi: "Konak Vergi Dairesi",
      city: "İzmir",
      district: "Bornova",
      address: "Kazım Dirik Mah. No:3",
    },
    {
      id: 7,
      fullName: "Murat Öz",
      email: "murat@example.com",
      phone1: "0555 777 88 99",
      phone2: "",
      customerType: "Bireysel",
      tcNo: "45678901234",
      vergiNo: "",
      vergiDairesi: "",
      city: "Bursa",
      district: "Nilüfer",
      address: "FSM Bulvarı No:20",
    },
    {
      id: 8,
      fullName: "Selin Yalçın",
      email: "selin@example.com",
      phone1: "0555 888 99 00",
      phone2: "",
      customerType: "Kurumsal",
      tcNo: "",
      vergiNo: "3692581470",
      vergiDairesi: "Nilüfer Vergi Dairesi",
      city: "Bursa",
      district: "Osmangazi",
      address: "Heykel Cd. No:6",
    },
    {
      id: 9,
      fullName: "Fatma Aydın",
      email: "fatma@example.com",
      phone1: "0555 111 00 11",
      phone2: "",
      customerType: "Bireysel",
      tcNo: "56789012345",
      vergiNo: "",
      vergiDairesi: "",
      city: "Antalya",
      district: "Muratpaşa",
      address: "Konyaaltı Cd. No:50",
    },
    {
      id: 10,
      fullName: "Okan Şahin",
      email: "okan@example.com",
      phone1: "0555 222 11 22",
      phone2: "",
      customerType: "Kurumsal",
      tcNo: "",
      vergiNo: "7418529630",
      vergiDairesi: "Muratpaşa Vergi Dairesi",
      city: "Antalya",
      district: "Kepez",
      address: "Şafak Mah. No:15",
    },
    {
      id: 11,
      fullName: "Gamze Polat",
      email: "gamze@example.com",
      phone1: "0555 333 22 33",
      phone2: "",
      customerType: "Bireysel",
      tcNo: "67890123456",
      vergiNo: "",
      vergiDairesi: "",
      city: "Eskişehir",
      district: "Odunpazarı",
      address: "Porsuk Cd. No:14",
    },
    {
      id: 12,
      fullName: "Burak Aksoy",
      email: "burak@example.com",
      phone1: "0555 444 33 44",
      phone2: "",
      customerType: "Kurumsal",
      tcNo: "",
      vergiNo: "9638527410",
      vergiDairesi: "Odunpazarı Vergi Dairesi",
      city: "Eskişehir",
      district: "Tepebaşı",
      address: "Bağlar Mh. No:45",
    },
    {
      id: 13,
      fullName: "Elif Kara",
      email: "elif@example.com",
      phone1: "0555 555 44 55",
      phone2: "",
      customerType: "Bireysel",
      tcNo: "78901234567",
      vergiNo: "",
      vergiDairesi: "",
      city: "Konya",
      district: "Selçuklu",
      address: "Mevlana Cd. No:7",
    },
    {
      id: 14,
      fullName: "Serkan Demirtaş",
      email: "serkan@example.com",
      phone1: "0555 666 55 66",
      phone2: "",
      customerType: "Kurumsal",
      tcNo: "",
      vergiNo: "1593574862",
      vergiDairesi: "Selçuklu Vergi Dairesi",
      city: "Konya",
      district: "Meram",
      address: "Zafer Mh. No:18",
    },
    {
      id: 15,
      fullName: "Hülya Çelik",
      email: "hulya@example.com",
      phone1: "0555 777 66 77",
      phone2: "",
      customerType: "Bireysel",
      tcNo: "89012345678",
      vergiNo: "",
      vergiDairesi: "",
      city: "Gaziantep",
      district: "Şahinbey",
      address: "Karataş Cd. No:9",
    },
    {
      id: 16,
      fullName: "Levent Gür",
      email: "levent@example.com",
      phone1: "0555 888 77 88",
      phone2: "",
      customerType: "Kurumsal",
      tcNo: "",
      vergiNo: "3571594862",
      vergiDairesi: "Şahinbey Vergi Dairesi",
      city: "Gaziantep",
      district: "Şehitkamil",
      address: "15 Temmuz Mh. No:13",
    },
    {
      id: 17,
      fullName: "Yasemin Uslu",
      email: "yasemin@example.com",
      phone1: "0555 999 88 99",
      phone2: "",
      customerType: "Bireysel",
      tcNo: "90123456789",
      vergiNo: "",
      vergiDairesi: "",
      city: "Adana",
      district: "Seyhan",
      address: "Barajyolu Cd. No:22",
    },
  ]);

  // Yeni müşteri ekleme
  const addCustomer = (customer) => {
    const newId = customers.length > 0 ? Math.max(...customers.map(c => c.id)) + 1 : 1;
    const newCustomer = { ...customer, id: newId };
    setCustomers(prev => [...prev, newCustomer]);
  };

  // Müşteri güncelleme
  const updateCustomer = (id, updatedData) => {
    setCustomers(prev =>
      prev.map(c => (c.id === id ? { ...c, ...updatedData } : c))
    );
  };

  // Müşteri silme
  const deleteCustomer = (id) => {
    setCustomers(prev => prev.filter(c => c.id !== id));
  };

  return (
    <CustomerContext.Provider value={{ customers, addCustomer, updateCustomer, deleteCustomer }}>
      {children}
    </CustomerContext.Provider>
  );
};
